export { default as GlobalStyle } from './GlobalStyle'
export { default as theme } from './ThemeObject'